import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/location/haridwar")({
  beforeLoad: () => {
    throw redirect({ to: "/locations/haridwar", replace: true, statusCode: 301 });
  },
});
